import { render } from "./SideActions.vue?vue&type=template&id=2e2b819c&scoped=true"
import script from "./SideActions.vue?vue&type=script&lang=js"
export * from "./SideActions.vue?vue&type=script&lang=js"

import "./SideActions.vue?vue&type=style&index=0&id=2e2b819c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2b819c"]])

export default __exports__